<template>
  <QuestionBase :question="question" :errors="[...errorsPost.full_name]" :valid="!!form.full_name">

    <div class="question-multipart-wrapper d-flex flex-wrap align-items-end">

      <div class="question question-multipart field-40">
        <label>Full Name</label>
        <InputBasic
            v-model="form.full_name"
            :errors-post="errorsPost.full_name"
            :db="db"
            :args="argsFullName"
            :skipped="skipped"
            :noSave="true"
            @skipped="skipped=$event"
            @serverErrors="serverErrors=$event"
            @jsErrors="jsErrors=$event"
        />
      </div>

    </div>
  </QuestionBase>
</template>

<script>
import {questionLoadHelpers} from "../../helpers/questionLoadHelpers";

import QuestionBase from "../../QuestionBase";
import InputBasic from "../../inputs/InputBasic";

export default {
  name: 'CardHolder',
  mixins: [questionLoadHelpers],
  components: {
    InputBasic,
    QuestionBase
  },
  props: {
    value: {
      type: Object,
      required: false
    },
    errorsPost: {
      type: Object,
      required: true
    }
  },
  computed: {
    form: {
      set(value) {
        this.$emit('input', value)
      },
      get() {
        return this.value
      }
    }

  },
  data() {
    return {
      question: {
        title: 'Cardholder',
        subTitle: null,
        tip: null
      },
      db: {
        saveLocation: null,
        saveField: null
      },
      argsNumber: {
        placeholder: 'e.g. 1112 23232 1211 1222',
        label: null,
        type: 'text',
        skippable: false,
        required: true,
        inputClass: 'field-100'
      },
      argsFullName: {
        placeholder: 'e.g. Mr J D Alexander',
        label: null,
        type: 'text',
        skippable: false,
        required: true,
        inputClass: 'field-100'
      },
      serverErrors: [],
      jsErrors: [],
      skipped: false,
    }
  }
}
</script>
